export const reportOptions = [
  "Inappropriate Content",
  "Harassment or Bullying",
  "False Information or Scams",
  "Privacy Concerns",
  "Violence or Threats",
  "Technical Issues",
];
